import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { CppCoiAddProductSliderModelService } from '../cpp-coi-add-product/cpp-coi-add-product-slider-model.service';
import { Router } from '@angular/router';
import { CommonService } from './../../../services/common/common.service';
import * as $ from 'jquery';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ErrorStateMatcher } from '@angular/material/core';
import { UntypedFormControl, FormGroupDirective, NgForm, AbstractControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { NgbCalendar, NgbDate, NgbDatepickerConfig, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { MatCalendar, MatCalendarCellCssClasses } from '@angular/material/datepicker';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog.component';
import { CppCoiRequestService } from '../../../services/cpp-coi-request/cpp-coi-request.service';
import { MatDialog } from '@angular/material/dialog';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';

//Service Class
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { MasterConstants } from '../../../common/constants/master-constants';
import { ToastrService } from 'ngx-toastr';
import { MatDatepicker } from "@angular/material/datepicker";
import { ConfigService } from './../../../services/infrastructure/config.service';
import { CppService } from '../../../services/cpp/cpp.service';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-cpp-coi-request-entry',
  templateUrl: './cpp-coi-request-entry.component.html',
  styleUrls: ['./cpp-coi-request-entry.component.scss']
  , animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class CppCoiRequestEntryComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('calendar') matcalendar: MatCalendar<Date>;
  @ViewChild('picker') datepicker: MatDatepicker<any>;
  @ViewChild('datepickerFooter') datepickerFooter: ElementRef;

  private subscription = new Array<Subscription>();
  private blkContactName: any;
  private pkgContactName: any;
  private lastBulkContactSearched: any;
  private lastPackagedContactSearched: any;
  private configurationMessage: any;

  coiOrderNumber = 0;
  soldToAccount: number;
  soldToDataLoading: any;
  soldToFacility: any[];
  shipToFacilityList: any[];
  shipToAccount: number;
  shipToAccountName: number;
  isEditMode = false;
  shipToDataLoading: any;
  readOnlyAccess = false;
  deliverToList: any[];
  deliverToAccount: number;
  deliverToDataLoading: any;
  deliverToAnotherLocation = false;
  specialInstructionText: string;
  purchaseOrder: string;
  isAddProductEnable = false;
  alphaNumericPattern: any = /^[A-Za-z0-9]+$/;
  alphaNumericPatternWithSpace: any = /^[A-Za-z0-9 ]+$/;
  isCustPONotValid = false;
  isNotValid = false;
  accountEmail: string;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  matcher = new InputErrorStateMatcher(this.isNotValid);
  isCustomerPickup = false;
  cppCoiOriginalProductItemsDataSource: any;
  cppCoiProductItemsDataSource: any;
  selectedCount = 0;
  disablecheckbox: any;
  allChecked = false;
  showTabs = false;
  isSearchClicked: any;
  editToolKit = false;
  tabNode: string;
  isReleased: any;
  datemodel: NgbDateStruct;
  isWeekend = (date: NgbDate) => this.calendar.getWeekday(date) == 7;
  isHoliday = (date: NgbDate) => this.getIsHoliday(date);
  selectedWeekdays = [];
  filteredDataCount = 0;
  qtyCount = 0;
  totalPrice = 0;
  showErrorBlock = false;
  errorMsgs = new Array();
  isWeekendForNonSDM = (date: NgbDate) => this.calendar.getWeekday(date) >= 6;
  displayedColumns: string[]
    = ['checkbox', 'product', 'viewDetail', 'AvailableUnits', 'RequestedUnits', 'orderUOM', 'packageSize', 'deliveryDate', 'deliveryDateReason'];
  index: any;
  nextErrorId = 1;
  currentErrorRow = 1;
  isPlaceOrderEnable = false;
  orderId = 0;
  headerCompany = MasterConstants.US_COMPANYCODE;
  isSaveOrderDraftEnable = false;
  instructionType: any;
  hasChangeAdded = false;
  date = new Date();
  maxDate = new Date(this.date.setMonth(this.date.getMonth() + 6));
  isAccontSDM = false;
  itemsIdsWithSDM: any;
  reasonList: any[];
  sdmSystemGeneratedDate?: Date = null;
  dateFilter: any;
  isSubscriptionAccess = true;
  public showBulkContactDetails = false;
  public showPackagedContactDetails = false;
  public cppDeliveryInstructionList: any[];
  public cppBulkContactInfo: any;
  public blkContactNumber: any;
  public cppPackagedDeliveryInstructionList: any[];
  public cppPackagedContactInfo: any;
  public pkgContactNumber: any;
  public cppDeliveryInstructionCode: any;
  public inputPackagedContactName$ = new Subject<string | null>();
  public inputBulkContactName$ = new Subject<string | null>();
  public bulkContactNumberTooltip: string;
  public isPhoneNotValid = false;
  public deliveryInstructionsCodeList: any = [{ id: 'PJK', value: 'Pallet Jack Required' }, { id: 'DRA', value: 'Driver Required Assistance' }, { id: 'UNMAN', value: 'Unmanned Location' }];

  constructor(
    private cppCoiAddProductSliderModelService: CppCoiAddProductSliderModelService,
    private router: Router,
    private calendar: NgbCalendar,
    private commonService: CommonService,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private configService: ConfigService,
    private cppCoiRequestService: CppCoiRequestService,
    private matDialog: MatDialog,
    private cppService: CppService,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private broadcastService: BroadcastService) {
    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    const tableHeight = window.innerHeight - 85;
    $('.requestCOIOuter').css('height', tableHeight + 'px');
  }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        // Set Subscription Access
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        this.isSubscriptionAccess = !isActiveUser.isSubscriptionAccess ? false : true;
        this.accountEmail = !isActiveUser.isSubscriptionAccess ? isActiveUser.emailId : '';

        this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.COI_ORDER);
      }
    }

    this.hasChangeAdded = false;

    this.loadMasterData();
    this.cppCoiProductItemsDataSource = new MatTableDataSource([]);
    this.cppCoiOriginalProductItemsDataSource = this.cppCoiProductItemsDataSource.data;
    this.disablecheckbox = true;
    this.subscription.push(this.cppCoiRequestService.OrderId.subscribe(x => {
      if (x && x != 0) {
        this.orderId = x;
        this.isEditMode = true;
        this.isAddProductEnable = true;
        this.getOrderDetails();
        this.enablePlaceOrderAndSaveOrderDraft();
      }
    }));

    // Logic for Add Product Grid
    this.subscription.push(this.cppCoiAddProductSliderModelService.cppCoiAddModelData.subscribe(selectedProductList => {
      if (selectedProductList.length > 0) {
        this.formatNewAddedData(selectedProductList);
        this.enablePlaceOrderAndSaveOrderDraft();
      }
    }));

    this.subscription.push(this.inputBulkContactName$.subscribe((newTerm) => {
      if (newTerm) {
        this.lastBulkContactSearched = newTerm;
      }
    }));

    this.subscription.push(this.inputPackagedContactName$.subscribe((newTerm) => {
      if (newTerm) {
        this.lastPackagedContactSearched = newTerm;
      }
    }));

    this.validateDateFilter();

    if (this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE)) {
      this.configurationMessage = JSON.parse(this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE));
      this.bulkContactNumberTooltip = this.configurationMessage.find(x => x.id === "EAU_BULK_CONTACT_NUMBER_MESSAGE")?.value;
    }
  }

  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      const calendarDate = d;// .getDate();

      // Prevent Saturday and Sunday from being selected.
      return calendarDate >= currentDate;
    };
  }

  createNewPackagedContact() {
    if (this.lastPackagedContactSearched) {
      var isContactNameExists = null;
      if (this.cppPackagedDeliveryInstructionList && this.cppPackagedDeliveryInstructionList.length > 0) {
        isContactNameExists = this.cppPackagedDeliveryInstructionList.filter(x => x.contactNamePhoneNumber == this.lastPackagedContactSearched)[0];
      }

      if (!isContactNameExists) {
        var primaryContact = { contactName: this.lastPackagedContactSearched, contactNamePhoneNumber: this.lastPackagedContactSearched, phoneNumber: '' };
        if (this.cppPackagedDeliveryInstructionList && this.cppPackagedDeliveryInstructionList.length > 0) {
          this.cppPackagedDeliveryInstructionList = [...this.cppPackagedDeliveryInstructionList, primaryContact];
        }
        else {
          this.cppPackagedDeliveryInstructionList = [primaryContact];
        }
        this.cppPackagedContactInfo = this.lastPackagedContactSearched;
        this.pkgContactName = this.lastPackagedContactSearched;
        this.pkgContactNumber = null;
      }
    }
  }

  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  addProduct() {
    this.cppCoiAddProductSliderModelService.shipToOrDeliverToAccount = this.deliverToAccount ? this.deliverToAccount : this.shipToAccount;
    this.cppCoiAddProductSliderModelService.shipToAccount = this.shipToAccount;
    this.cppCoiAddProductSliderModelService.isCustomerPickup = this.isCustomerPickup;
    this.cppCoiAddProductSliderModelService.activeSlider('AddCppCoiProductSlider');
  }

  navigateToLandingPage() {
    this.router.navigate(['/cpp/cpp-coi-landing']);
    this.commonService.currentTabIndex.next(1);
  }

  // On page destroy
  ngOnDestroy() {
    this.cppCoiRequestService.setCoiOrderIdCPP(0);
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  getShipTo(event) {
    if (event) {
      this.checkAccountSDMEnabled();

      // Check for existing Draft Order
      this.subscription.push(this.cppCoiRequestService.checkExistingCOIDraftOrder(this.shipToAccount).subscribe((result: any) => {
        if (result) {
          // Added Popup
          const title = 'Confirmation';
          const message = 'There is an existing Draft order for the selected account. Do you want to continue with that?';
          const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
            disableClose: true,
            width: '350px',
            data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
          });

          this.subscription.push(dialogRef.afterClosed().subscribe(yes => {
            if (yes == true) {// User selected Yes
              this.cppCoiRequestService.setCoiOrderIdCPP(+parseInt(result));
            }
          }));
        }
      }));

      this.loaderService.setLoaderStatus(true);

      this.subscription.push(this.cppService.getCPPDeliveryInstruction(event.accountNumber).subscribe((result: any[]) => {
        if (result && result.length > 0) {
          let bulkCppDeliveryInstruction = result.filter(x => x.packagedType === 'BULK');
          if (bulkCppDeliveryInstruction && bulkCppDeliveryInstruction.length > 0) {
            bulkCppDeliveryInstruction.map(x => {
              x['contactNamePhoneNumber'] = x.firstName + x.lastName + x.phoneNumber;
              x['contactName'] = x.firstName + ' ' + x.lastName;
            });

            this.cppDeliveryInstructionList = bulkCppDeliveryInstruction;

            const primaryContact = bulkCppDeliveryInstruction.filter(x => x.contactType.toUpperCase() === 'PRIMARY')[0];

            if (primaryContact) {
              this.cppBulkContactInfo = primaryContact.contactNamePhoneNumber;
              this.blkContactName = primaryContact.contactName;
              this.blkContactNumber = primaryContact.phoneNumber;
            }
            else {
              this.cppBulkContactInfo = bulkCppDeliveryInstruction[0].contactNamePhoneNumber;
              this.blkContactName = bulkCppDeliveryInstruction[0].contactName;
              this.blkContactNumber = bulkCppDeliveryInstruction[0].phoneNumber;
            }
          }
          else {
            this.cppBulkContactInfo = null;
            this.blkContactName = null;
            this.blkContactNumber = null;
            this.cppDeliveryInstructionList = null;
          }

          let packagedCppDeliveryInstruction = result.filter(x => x.packagedType === 'PACKAGED');

          if (packagedCppDeliveryInstruction && packagedCppDeliveryInstruction.length > 0) {
            packagedCppDeliveryInstruction.map(x => {
              x['contactNamePhoneNumber'] = x.firstName + x.lastName + x.phoneNumber;
              x['contactName'] = x.firstName + ' ' + x.lastName;
            });

            this.cppPackagedDeliveryInstructionList = packagedCppDeliveryInstruction;

            const primaryContact = packagedCppDeliveryInstruction.filter(x => x.contactType.toUpperCase() === 'PRIMARY')[0];

            if (primaryContact) {
              this.cppPackagedContactInfo = primaryContact.contactNamePhoneNumber;
              this.pkgContactName = primaryContact.contactName;
              this.pkgContactNumber = primaryContact.phoneNumber;
              if (primaryContact.deliveryInstructions) {
                this.cppDeliveryInstructionCode = primaryContact.deliveryInstructions.split(',');
              }
              else {
                this.cppDeliveryInstructionCode = new Array<string>();
              }
            }
            else {
              this.cppPackagedContactInfo = packagedCppDeliveryInstruction[0].contactNamePhoneNumber;
              this.pkgContactName = packagedCppDeliveryInstruction[0].contactName;
              this.pkgContactNumber = packagedCppDeliveryInstruction[0].phoneNumber;
            }
          }
          else {
            this.cppPackagedContactInfo = null;
            this.pkgContactName = null;
            this.pkgContactNumber = null;
            this.cppPackagedDeliveryInstructionList = null;
          }
        }
        else {
          this.cppBulkContactInfo = null;
          this.blkContactName = null;
          this.blkContactNumber = null;
          this.cppDeliveryInstructionList = null;
          this.cppPackagedContactInfo = null;
          this.pkgContactName = null;
          this.pkgContactNumber = null;
          this.cppPackagedDeliveryInstructionList = null;
        }

        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));

      this.cppCoiRequestService.setSelectedAccountNo(this.shipToAccount);

      this.subscription.push(this.cppCoiRequestService.getCoiDeliverTo(event.accountNumber, event.parentNumber).subscribe((result: any[]) => {
        this.deliverToList = result;
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));

      this.subscription.push(this.cppCoiRequestService.getCoiSoldTo(event.accountNumber).subscribe((result: any[]) => {
        this.soldToFacility = [result];
        this.soldToAccount = this.soldToFacility[0].accountNumber;
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));

      this.shipToAccountName = event.accountName;
      this.isAddProductEnable = true;   // Enable Add Product Button
    } else {
      this.deliverToList = null;
      this.deliverToAccount = null;
      this.soldToFacility = null;
      this.soldToAccount = null;
      this.isAddProductEnable = false;   // Disable Add Product Button
      this.disablecheckbox = true;
    }
    this.errorMsgs = new Array();
    this.showErrorBlock = false;
    this.editToolKit = false;
    this.showTabs = false;
    this.cppCoiProductItemsDataSource.data = [];
    this.cppCoiOriginalProductItemsDataSource = [];
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  getDeliverTo($event) {
    this.checkAccountSDMEnabled(false);
    this.getDefaultDeliveryDate();

    if ($event && this.isEditMode) {
      this.isAddProductEnable = true;   // Enable Add Product Button
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppDeliverToValue: true });
    }
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  hasHeaderInfoChanged(fieldName) {
    if (fieldName && this.shipToAccount && this.isEditMode) {
      this.isAddProductEnable = true;   // Enable Add Product Button
      switch (fieldName) {
        case 'PO':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppPOValue: true });
          break;
        case 'Special Instructions':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppSplInsValue: true });
          break;
        case 'Instruction Type':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppInsTypeValue: true });
          break;
        case 'Customer Pickup':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppCustPickupValue: true });
          break;
        case 'Email Address':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppEmailAddressValue: true });
          break;
        case 'Bulk Name':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppBulkNameValue: true });
          break;
        case 'Bulk Number':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppBulkNumberValue: true });
          break;
      }
      this.enablePlaceOrderAndSaveOrderDraft();
    }
  }

  UpdateDeliverToSelection(isDeliverToOptionChecked) {
    if (!isDeliverToOptionChecked) {
      this.deliverToAccount = null;
      this.checkAccountSDMEnabled(false);
      this.getDefaultDeliveryDate();
    }
  }

  checkAnyValidLineItem() {
    const errorCount = this.cppCoiProductItemsDataSource.data.filter(x => x.lineErrors.errors.length > 0).length;
    return (errorCount > 0 ? false : true);
  }

  enablePlaceOrderAndSaveOrderDraft() {
    if (this.readOnlyAccess) {
      this.isSaveOrderDraftEnable = false;
      this.isPlaceOrderEnable = false;
    }
    else {
      if (this.cppCoiOriginalProductItemsDataSource && this.cppCoiOriginalProductItemsDataSource.length > 0 && this.shipToAccount
        && (!this.isNotValid)
        && this.checkAnyValidLineItem()) {
        this.isSaveOrderDraftEnable = true;
        this.isPlaceOrderEnable = true;
      }
      else {
        this.isSaveOrderDraftEnable = false;
        this.isPlaceOrderEnable = false;
      }
    }
  }

  keyPressAlphaNumeric(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (this.alphaNumericPattern.test(inp)) {
      this.validateCustPO();
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  validateCustPO() {
    this.isCustPONotValid = false;
    if (this.purchaseOrder && !this.alphaNumericPattern.test(this.purchaseOrder)) {
      this.isCustPONotValid = true;
    };
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // Validate the email address entered
  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
    if (this.isNotValid) {
      this.isSaveOrderDraftEnable = false;
      this.isPlaceOrderEnable = false;
    }
    else {
      this.enablePlaceOrderAndSaveOrderDraft();
    }
    this.matcher = new InputErrorStateMatcher(this.isNotValid);
  }

  customerPickupChange() {
    this.checkAccountSDMEnabled(false);
    this.getDefaultDeliveryDate();
  }

  checkAccountSDMEnabled(resetReasonCodeRequire: boolean = true) {
    const accountNumber = this.deliverToAccount ? this.deliverToAccount : this.shipToAccount;
    this.subscription.push(this.cppCoiRequestService.getAccountSDMData(accountNumber).subscribe((result) => {
      this.isAccontSDM = result.isSDM;
      this.sdmSystemGeneratedDate = null;
      if (result.isSDM) {
        this.fetchSDMReasonCodes();
      }
      this.selectedWeekdays = result.isSDM ? result.daysData : [];
      if (resetReasonCodeRequire && this.cppCoiProductItemsDataSource && this.cppCoiProductItemsDataSource.data && this.cppCoiProductItemsDataSource.data.length > 0) {
        this.cppCoiProductItemsDataSource.data.forEach(x => {
          this.reasonCodeRequire(x);
        });
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getDefaultDeliveryDate() {
    const accountNumber = this.deliverToAccount ? this.deliverToAccount : this.shipToAccount;
    const itemIds = this.cppCoiProductItemsDataSource.data.map(y => y.itemId);
    if (itemIds.length > 0) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.cppCoiRequestService.getItemsSDM(itemIds.join(','), accountNumber, this.isCustomerPickup).subscribe((result) => {
        this.itemsIdsWithSDM = result;

        this.cppCoiProductItemsDataSource.data.forEach(x => {
          const item = this.itemsIdsWithSDM.filter(f => f.itemId == x.itemId)[0];
          x.deliveryDate = item.desiredDelDate;
          x.defaultDeliveryDate = item.defaultDelDate;
          x.isLineSDM = item.isLineSDM;
          x.isReasonMandatory = false;
          x.deliveryDateReason = '';
        });

        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));
    }
  }

  enableAllCheckBoxes(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.cppCoiProductItemsDataSource.data.forEach(x => {
        x.isSelected = true;
      });
      this.selectedCount = this.cppCoiProductItemsDataSource.data.length;
    }
    else {
      this.showTabs = false;
      this.cppCoiProductItemsDataSource.data.forEach(x => {
        x.isSelected = false;
      });
      this.selectedCount = 0;
    }
    const checked = this.cppCoiProductItemsDataSource.data.filter(x => x.isSelected == true);
    if (checked) {
      this.editToolKit = (checked.length > 0);
      this.validateDeliveryDateFilter();
    }
  }

  // Set Tab to show
  showTab(tabid: string) {
    this.tabNode = tabid;
  }

  isAnyLineSMDSelected() {
    const sdmLines = this.cppCoiProductItemsDataSource.data.filter(x => x.isSelected == true && x.isLineSDM == true);
    if (this.sdmSystemGeneratedDate == null && sdmLines && sdmLines.length > 0) {
      this.sdmSystemGeneratedDate = new Date(sdmLines[0].defaultDeliveryDate);
    }
    return sdmLines && sdmLines.length > 0;
  }

  // highlighting weekdays
  getIsHoliday(date: NgbDate) {
    const todayDate = new Date();
    if (this.isAnyLineSMDSelected()
      && new Date(date.year, date.month - 1, date.day) >= this.sdmSystemGeneratedDate
      && new Date(date.year, date.month - 1, date.day) >= todayDate) {
      return this.selectedWeekdays.includes(this.calendar.getWeekday(date));
    } else {
      return false;
    }
  }

  SetAllFields(field: string, value: any) {
    switch (field) {
      case 'delete':
        if (value == true) {
          const refreshData = [];
          this.cppCoiProductItemsDataSource.data.forEach(item => {
            if (item.isSelected) {
              this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppPOValue: true });
              refreshData.push(item.itemId);
              this.selectedCount = this.selectedCount - 1;
              item.isSelected = false;
            }
          });

          const filterDataAfterDeletion = this.cppCoiProductItemsDataSource.data.filter(x => refreshData.indexOf(x.itemId) == -1);
          if (filterDataAfterDeletion.length < 1) {
            this.disablecheckbox = true;
          }
          this.cppCoiProductItemsDataSource = new MatTableDataSource(filterDataAfterDeletion);
          this.cppCoiOriginalProductItemsDataSource = JSON.parse(JSON.stringify(this.cppCoiProductItemsDataSource.data));
          this.enablePlaceOrderAndSaveOrderDraft();
        }
        this.setCount();
        this.tabNode = '';
        this.enableAllCheckBoxes(false);
        this.selectedCount = 0;
        this.editToolKit = false;
        this.showTabs = false;
        this.showErrorBlock = false;
        break;

      case 'deliverydate':
        this.cppCoiProductItemsDataSource.data.forEach(item => {
          if (item.isSelected) {
            item.deliveryDate = new Date(value.year, value.month - 1, value.day);
            this.validateDate(item);
            this.selectedCount = this.selectedCount - 1;
            item.isSelected = false;
          }
        });

        this.cppCoiOriginalProductItemsDataSource = JSON.parse(JSON.stringify(this.cppCoiProductItemsDataSource.data));
        this.setCount();
        this.enableAllCheckBoxes(false);
        this.selectedCount = 0;
        this.validateDeliveryDateFilter();
        this.showTabs = false;
        this.editToolKit = false;
        break;
      default:
        break;
    }
  }

  setCount() {
    this.filteredDataCount = 0;
    this.qtyCount = 0;
    this.totalPrice = 0;
    this.filteredDataCount = this.cppCoiProductItemsDataSource.data.length;
    this.cppCoiProductItemsDataSource.data.forEach(x => {
      this.qtyCount = this.qtyCount + +(x.quantity);
      this.totalPrice = this.totalPrice + (x.quantity * x.price);
    });
  }

  // Date validation
  validateDate(productItem: any) {
    const oldProductLineValue = JSON.parse(JSON.stringify(this.cppCoiOriginalProductItemsDataSource)).filter(x => x.rowId == productItem.rowId)[0];
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldCPPCOIDateValue: oldProductLineValue.deliveryDate, newCPPCOIDateValue: productItem.deliveryDate });

    if (productItem.isLineSDM) {
      this.cppCoiProductItemsDataSource.data.forEach(item => {
        // update reason code if delivery dates are same
        if (item.rowId != productItem.rowId && item.isLineSDM
          && new Date(item.deliveryDate).getTime() == new Date(productItem.deliveryDate).getTime()) {
          productItem.deliveryDateReason = item.deliveryDateReason;
          return;
        }
      });
      this.reasonCodeRequire(productItem);
    }

    if (productItem.lineErrors && productItem.lineErrors.errors && productItem.lineErrors.errors.length > 0) {
      this.validateLineItem(productItem);
    }
    this.isAddProductEnable = true;   // Enable Add Product Button
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  reasonCodeRequire(productItem: any) {
    if (productItem.isLineSDM) {
      const dDate = new Date(productItem.deliveryDate);
      const ngDate: NgbDate = new NgbDate(dDate.getFullYear(), dDate.getMonth() + 1, dDate.getDate());

      if (this.selectedWeekdays.some(x => x == this.calendar.getWeekday(ngDate))
        && new Date(productItem.defaultDeliveryDate).getTime() <= new Date(productItem.deliveryDate).getTime()) {
        productItem.isReasonMandatory = false;
        productItem.deliveryDateReason = '';
      }
      else {
        productItem.isReasonMandatory = true;
      }
    }
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.selectedCount = this.selectedCount + 1;
      const checked = this.cppCoiProductItemsDataSource.data.filter(x => x.isSelected == false);
      if (checked && checked.length == 0) {
        this.allChecked = true;
      }
      else {
        this.allChecked = false;
      }
    }
    else {
      this.selectedCount = this.selectedCount - 1;
      this.allChecked = false;
      const checked = this.cppCoiProductItemsDataSource.data.filter(x => x.isSelected == true);
      {
        if (checked && checked.length == 0) {
          this.showTabs = false;
        }
      }
    }
    const checked = this.cppCoiProductItemsDataSource.data.filter(x => x.isSelected == true);
    if (checked) {
      this.editToolKit = (checked.length > 0);
      this.validateDeliveryDateFilter();
    }
  }

  // Line item validation
  validateLineItem(item: any) {
    if (item.quantity <= 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
      item.lineErrors.errors.push({ id: 'quantity', error: 'Quantity should be greater than zero' });
    }
    else if (item.quantity > item.AvailableUnits) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
      item.lineErrors.errors.push({ id: 'quantity', error: 'The item quantity exceeds the remaining quantity available. Reduce the item quantity to continue.' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }

    const currentDate = (new Date()).toLocaleDateString('en-US').replace(/\u200E/g, '');
    if (item.deliveryDate == null || item.deliveryDate == '') {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deliveryDate');
      item.lineErrors.errors.push({ id: 'deliveryDate', error: 'Requested Arrival Date is required.' });
    }
    else if (Date.parse((new Date(item.deliveryDate)).toLocaleDateString('en-US').replace(/\u200E/g, '')) < Date.parse(currentDate)) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deliveryDate');
      item.lineErrors.errors.push({ id: 'deliveryDate', error: 'Requested Arrival Date should be greater than equal to current date.' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deliveryDate');
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }

    if (item.isLineSDM && item.isReasonMandatory && !item.deliveryDateReason) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deliveryDateReason');
      item.lineErrors.errors.push({ id: 'deliveryDateReason', error: 'Please enter Reason Code.' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deliveryDateReason');
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }

    this.enablePlaceOrderAndSaveOrderDraft();
    return item;
  }

  validateDeliveryDateFilter() {
    const currentDate = new Date();
    this.config.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
    this.config.maxDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 7, day: currentDate.getDate() };
    // this.datemodel = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() + 4 };//this.configDate.getToday();

    const sdmlines = this.cppCoiProductItemsDataSource.data.filter(x => x.isSelected == true /* && x.islinesdm == true*/);
    const selecteLineCount = sdmlines.length;
    if (sdmlines && selecteLineCount > 0) {
      // if all lines selected are non sdm
      if (sdmlines.filter(x => x.isLineSDM == false).length == selecteLineCount) {
        this.datemodel = this.configDate.getToday();
      }
      else {
        const firstdate = sdmlines[0].deliveryDate;
        const datecount = sdmlines.filter(x => new Date(x.deliveryDate).getTime() == new Date(firstdate).getTime()).length;

        // if all selected lines has same dates
        if (datecount == selecteLineCount) {
          const fDate = new Date(firstdate);
          this.datemodel = { year: fDate.getFullYear(), month: fDate.getMonth() + 1, day: fDate.getDate() };
        }
        else {
          this.datemodel = this.configDate.getToday();
        }
      }
    }
    else {
      this.datemodel = this.configDate.getToday();
    }

    this.tabNode = '';
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#cppOrderView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
        $('#cppOrderView').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#cppOrderView').scrollTop = 0;
      $('#cppOrderView').animate({ scrollTop: 0 }, 1000);
    }
  }

  placeCoiOrder() {
    $('#cppOrderView').animate({ scrollTop: 0 }, 'slow');
    this.isPlaceOrderEnable = false;
    const saveObj: any = {};
    saveObj.OrderId = this.orderId;
    saveObj.shipToAccountId = this.shipToAccount;
    saveObj.deliverToId = this.deliverToAccount;
    saveObj.soldToId = this.soldToAccount;
    saveObj.purchaseOrderNumber = this.purchaseOrder;
    saveObj.companycode = this.headerCompany;

    saveObj.bulkContactName = this.showBulkContactDetails ? this.blkContactName : null;
    saveObj.bulkContactPhoneNumber = this.showBulkContactDetails ? this.blkContactNumber : null;
    saveObj.packagedContactName = this.showPackagedContactDetails ? this.pkgContactName : null;
    saveObj.packagedContactNumber = this.showPackagedContactDetails ? this.pkgContactNumber : null;
    saveObj.packagedDeliveryInst = this.showPackagedContactDetails && this.cppDeliveryInstructionCode && this.cppDeliveryInstructionCode.length > 0 ? this.cppDeliveryInstructionCode.join(',') : null;

    if ((this.specialInstructionText && (this.specialInstructionText.trim() != ''))) {
      saveObj.headerText = this.specialInstructionText.trim();
      saveObj.instructionType = 41;// this.instructionType;//check this later
    }

    if ((this.specialInstructionText && (this.specialInstructionText.trim() != ""))) {
      saveObj.headerText = this.specialInstructionText.trim();
      saveObj.instructionType = 41;//this.instructionType;//check this later
    }

    if ((this.specialInstructionText && (this.specialInstructionText.trim() != ""))) {
      saveObj.headerText = this.specialInstructionText.trim();
      saveObj.instructionType = 41;//this.instructionType;//check this later
    }

    saveObj.emailAddress = this.accountEmail;
    saveObj.customerPickUp = this.isCustomerPickup;
    saveObj.CppCoiProductList = this.cppCoiProductItemsDataSource.data;

    saveObj.CppCoiProductList.forEach(x => {
      x.deliverydate = (new Date(x.deliveryDate)).toLocaleDateString('en-US').replace(/\u200E/g, '');
    });
    let isValidated = true;
    if (this.validateOrder(false)) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.cppCoiRequestService.placeCoiOrder(saveObj).subscribe((result: any) => {
        if (result) {
          if (result.errors.length > 0) {
            result.errors.forEach(x => {
              this.toastrService.error(x);
              isValidated = false;
              return false;
            });
          }

          if (result.cppCoiProductList.length > 0) {
            const CppCoiProductList = result.cppCoiProductList;
            this.cppCoiProductItemsDataSource.data.forEach(x => {
              const item = CppCoiProductList.filter(z => z.itemId == x.itemId);

              if (item[0].isInValidItem) {
                isValidated = false;
                x.lineErrors.errors = x.lineErrors.errors.filter(y => y.id != 'validItem');
                x.lineErrors.errors.push({ id: 'validItem', error: 'This product is not available for ordering' });
              }
              else {
                x.lineErrors.errors = x.lineErrors.errors.filter(y => y.id != 'validItem');
                x.lineErrors.errors = item[0].lineErrors.errors;
                this.errorMsgs = this.errorMsgs.filter(y => y.rowId != item.rowId);
              }

              if (x.lineErrors.errors.length > 0) {
                isValidated = false;
                this.errorMsgs.push(x.lineErrors);
                this.getCommonErrors(this.errorMsgs);
              }
            });
          }

          if (isValidated) {
            this.toastrService.success('Order #' + result.coiOrderNumber + ' placed successfully.');
            this.cppCoiRequestService.webOrderNumberAndSplitId = result.coiOrderNumber + '~' + 0 + '~ ' + '~CppCoiLanding';// Done '~ ' so that we could show non errored data
            this.router.navigate(['cpp/cpp-coi-request-confirmation']);;
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          }
          this.loaderService.setLoaderStatus(false);
        }
      }, (error) => {
        this.isPlaceOrderEnable = true;
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Order not saved in the system.');
        LolLoggerService.error(error);
      }));
    }
  }

  saveCoiDraft() {
    $('#cppOrderView').animate({ scrollTop: 0 }, 'slow');
    const saveObj: any = {};
    saveObj.isUpdateRequest = (this.isEditMode) ? true : false;
    saveObj.orderId = this.orderId;
    saveObj.companyCode = this.headerCompany;
    saveObj.shipToAccountId = this.shipToAccount;
    saveObj.deliverToId = this.deliverToAccount;
    saveObj.soldToId = this.soldToAccount;
    saveObj.purchaseOrderNumber = this.purchaseOrder;

    saveObj.bulkContactName = this.showBulkContactDetails ? this.blkContactName : null;
    saveObj.bulkContactPhoneNumber = this.showBulkContactDetails ? this.blkContactNumber : null;
    saveObj.packagedContactName = this.showPackagedContactDetails ? this.pkgContactName : null;
    saveObj.packagedContactNumber = this.showPackagedContactDetails ? this.pkgContactNumber : null;
    saveObj.packagedDeliveryInst = this.cppDeliveryInstructionCode && this.cppDeliveryInstructionCode.length > 0 ? this.cppDeliveryInstructionCode.join(',') : null;

    if ((this.specialInstructionText && (this.specialInstructionText != ''))) {
      saveObj.instructionType = 41;
    }

    saveObj.headerText = this.specialInstructionText;
    saveObj.emailAddress = this.accountEmail;
    saveObj.customerPickUp = this.isCustomerPickup;
    saveObj.cppCoiProductList = JSON.parse(JSON.stringify(this.cppCoiProductItemsDataSource.data));

    saveObj.cppCoiProductList.forEach(x => {
      x.deliverydate = (new Date(x.deliveryDate)).toLocaleDateString('en-US').replace(/\u200E/g, '');
    });

    if (this.validateOrder(true)) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.cppCoiRequestService.saveCoiOrder(saveObj).subscribe((result: any) => {
        if (result) {
          if (result.errors.length > 0) {
            this.loaderService.setLoaderStatus(false);
            result.errors.forEach(x => {
              this.toastrService.error(x);
              return false;
            });
          }
          else {
            const successMsg = (this.isEditMode) ? 'Order #' + result.coiOrderNumber + ' updated successfully.' : 'COI Order #' + result.coiOrderNumber + ' saved successfully.';
            this.toastrService.success(successMsg);
            this.router.navigate(['/cpp/cpp-coi-landing']);
            this.commonService.currentTabIndex.next(1);
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
            this.loaderService.setLoaderStatus(false);
          }
        }
      }, (error) => {
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Order not saved in the system.');
        LolLoggerService.error(error);
      }));
    }
  }

  // validation on Save Draft
  validateOrder(isDraftCall) {
    isDraftCall = isDraftCall ? isDraftCall : false;
    let isValidated = true;
    if (this.cppCoiProductItemsDataSource.data && this.cppCoiProductItemsDataSource.data.length > 0) {
      isValidated = true;
      this.cppCoiProductItemsDataSource.data.forEach(x => {
        if (!isDraftCall) {
          x = this.validateLineItem(x);
          if (x.lineErrors.errors.length > 0) {
            this.errorMsgs.push(x.lineErrors);
            this.getCommonErrors(this.errorMsgs);
            isValidated = false;
          }
        }
      });
    }
    return isValidated;
  }

  // Show/Hide Product Detail section
  showDetails(event: UIEvent, element, column): void {
    element.selected = column.toString();
  }

  showProductDetails(item) {
    item.isProductDetailDisplayed = !item.isProductDetailDisplayed;
  }

  // Load master data
  loadMasterData() {
    this.loaderService.setLoaderStatus(true);

    // get Cpp Ship To Facility List
    const getcoiShipToFacility = this.cppCoiRequestService.getCoiShipToAccountDataList();
    this.subscription.push(forkJoin(getcoiShipToFacility).subscribe((result: any[]) => {
      this.shipToFacilityList = result[0];
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    let deliverToAccount: number;
    let soldToAccount: number;
    this.loaderService.setLoaderStatus(true);

    this.subscription.push(this.cppCoiRequestService.getCppCoiEditOrderDetail(this.orderId).subscribe((result: any) => {
      this.coiOrderNumber = result.coiOrderNumber;
      this.shipToAccount = result.shipToAccountId;
      this.shipToAccountName = result.shipToAccountName;
      deliverToAccount = result.deliverToAccountId;
      soldToAccount = result.soldToAccountId;
      this.purchaseOrder = result.purchaseOrder;
      this.accountEmail = result.emailAddress;
      this.blkContactName = result.bulkContactName;
      this.blkContactNumber = result.bulkContactPhoneNumber;
      this.pkgContactName = result.packagedContactName;
      this.pkgContactNumber = result.packagedContactNumber;
      if (result.packagedDeliveryInst) {
        this.cppDeliveryInstructionCode = result.packagedDeliveryInst.split(',');
      }
      else {
        this.cppDeliveryInstructionCode = new Array<string>();
      }
      this.specialInstructionText = result.specialInstruction == null ? '' : result.specialInstruction;
      this.instructionType = result.instructionType;
      this.isCustomerPickup = result.customerPickUp;
      this.formatEditOrderData(result.productList);

      this.subscription.push(this.cppService.getCPPDeliveryInstruction(this.shipToAccount).subscribe((resultDI: any[]) => {
        if (resultDI && resultDI.length > 0) {
          let bulkCppDeliveryInstruction = resultDI.filter(x => x.packagedType === 'BULK');

          if (bulkCppDeliveryInstruction && bulkCppDeliveryInstruction.length > 0) {
            bulkCppDeliveryInstruction.map(x => {
              x['contactNamePhoneNumber'] = x.firstName + x.lastName + x.phoneNumber;
              x['contactName'] = x.firstName + ' ' + x.lastName;
            });

            this.cppDeliveryInstructionList = bulkCppDeliveryInstruction;
          }

          let packagedCppDeliveryInstruction = resultDI.filter(x => x.packagedType === 'PACKAGED');

          if (packagedCppDeliveryInstruction && packagedCppDeliveryInstruction.length > 0) {
            packagedCppDeliveryInstruction.map(x => {
              x['contactNamePhoneNumber'] = x.firstName + x.lastName + x.phoneNumber;
              x['contactName'] = x.firstName + ' ' + x.lastName;
            });

            this.cppPackagedDeliveryInstructionList = packagedCppDeliveryInstruction;
          }

          if (this.blkContactName && this.blkContactNumber) {
            const selectedContact = this.blkContactName.replace(/ /g, '') + this.blkContactNumber;
            let primaryContact = bulkCppDeliveryInstruction.filter(x => x.contactNamePhoneNumber === selectedContact)[0];

            if (primaryContact) {
              this.cppBulkContactInfo = primaryContact.contactNamePhoneNumber;
            }
            else {
              primaryContact = { contactName: this.blkContactName, contactNamePhoneNumber: selectedContact, phoneNumber: this.blkContactNumber };
              this.cppDeliveryInstructionList.push(primaryContact);
              this.cppBulkContactInfo = selectedContact;
            }
          }

          if (this.pkgContactName && this.pkgContactNumber) {
            const selectedContact = this.pkgContactName.replace(/ /g, '') + this.pkgContactNumber;
            let primaryContact = packagedCppDeliveryInstruction.filter(x => x.contactNamePhoneNumber === selectedContact)[0];

            if (primaryContact) {
              this.cppPackagedContactInfo = primaryContact.contactNamePhoneNumber;
            }
            else {
              primaryContact = { contactName: this.pkgContactName, contactNamePhoneNumber: selectedContact, phoneNumber: this.pkgContactNumber };
              this.cppPackagedDeliveryInstructionList.push(primaryContact);
              this.cppPackagedContactInfo = selectedContact;
            }
          }
        }

        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));

      this.subscription.push(this.cppCoiRequestService.getCoiDeliverTo(result.shipToAccountId, result.parentAccountId).subscribe((result: any[]) => {
        this.deliverToList = result;
        this.deliverToAccount = deliverToAccount;
        this.deliverToAnotherLocation = deliverToAccount ? true : false;
        this.checkAccountSDMEnabled();
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));

      this.subscription.push(this.cppCoiRequestService.getCoiSoldTo(result.shipToAccountId).subscribe((result: any[]) => {
        this.soldToFacility = [result];
        this.soldToAccount = soldToAccount;
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));
      this.cppCoiRequestService.setSelectedAccountNo(this.shipToAccount);
      this.loaderService.setLoaderStatus(false);
      this.enablePlaceOrderAndSaveOrderDraft();
      this.isSaveOrderDraftEnable = false;
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Formate Data for edit a draft order
  formatEditOrderData(productList: any[]) {
    const orderList = [];
    this.filteredDataCount = 0;
    this.qtyCount = 0;
    this.totalPrice = 0;
    let rowId = 0;
    this.cppCoiProductItemsDataSource.data.forEach(x => {
      orderList.push(x);
      if (x.rowId > rowId) { rowId = x.rowId; }
    });

    productList.forEach(x => {
      rowId = rowId + 1;
      const duplicateData = orderList.find(y => y.itemNumber == x.itemNumber && y.orderUOM == x.orderUOM);
      if (duplicateData == undefined) {
        const newRow = {
          rowId: rowId,
          isSelected: false,
          isProductDetailDisplayed: false,
          itemId: x.itemId,
          itemNumber: x.itemNumber,
          itemDescription: x.itemDescription,
          itemVendorName: x.itemVendorName,
          packageSize: x.packageSize,
          gtin: x.gtin,
          activeIngredient: x.activeIngredient,
          productSegment: x.productSegment,
          productLine: x.productLine,
          palletQuantity: x.palletQuantity,
          restrictedUse: x.restrictedUse,
          returnable: x.returnable,
          uom: x.orderUOM,
          orderUOM: x.orderUOM,
          pricingUOM: x.pricingUOM,
          price: x.price,
          isParent: x.isParent,
          deliveryDate: x.deliveryDate,
          defaultDeliveryDate: x.defaultDelDate,
          quantity: x.allowDecimal ? x.orderQty.toFixed(this.commonService.countDecimals(x.orderQty)) : x.orderQty,
          lineErrors: { 'rowId': rowId, 'errors': [] },
          orderConvFactor: x.orderUOM == 'IB' ? x.orderConvFactor : 1,
          modifiedOrderingUOM: x.modifiedOrderUOM,
          modifiedUOMConverted: x.modifiedUOMConverted,
          pricingQuantity: x.pricingUnitConvFactor,
          pricingUnitConvFactor: x.pricingUnitConvFactor,
          allowDecimal: x.allowDecimal,
          warningMessage: x.warningMessage,
          isLineSDM: x.isLineSDM,
          deliveryDateReason: x.deliveryDateChangeReason,
          AvailableUnits: x.availableUnits,
          bulkPackaged: x.bulkPackaged
        };
        orderList.splice(orderList.length, 0, newRow);
      }
    });

    this.filteredDataCount = orderList.length;
    this.cppCoiProductItemsDataSource.data = orderList;
    this.cppCoiOriginalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
    this.showBulkContactDetails = this.cppCoiOriginalProductItemsDataSource.some(x => x.bulkPackaged.toUpperCase() === "BULK");
    this.showPackagedContactDetails = this.cppCoiOriginalProductItemsDataSource.some(x => x.bulkPackaged.toUpperCase() === "PACKAGED");
    this.validateDeliveryDateFilter();

    if (this.cppCoiProductItemsDataSource.data.length > 0) {
      this.disablecheckbox = false;
    }
    else {
      this.disablecheckbox = true;
    }
  }

  //Validate Bulk Phone Number
  public phoneShouldBeValid(phone: AbstractControl) {
    this.isPhoneNotValid = false;
    if (phone.valid) {
      this.isPhoneNotValid = false;
    } else {
      this.isPhoneNotValid = true;
    }
    this.matcher = new InputErrorStateMatcher(this.isPhoneNotValid);
  }

  //Search the bulk contact name
  public bulkContactNameSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.firstName.toLocaleLowerCase().indexOf(term) > -1
      || item.lastName.toLocaleLowerCase().indexOf(term) > -1;
  }

  //Search the bulk contact name
  public packagedContactNameSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.firstName.toLocaleLowerCase().indexOf(term) > -1
      || item.lastName.toLocaleLowerCase().indexOf(term) > -1;
  }

  public getBulkContactPhone(event) {
    if (event && event.contactName && event.phoneNumber) {
      this.blkContactNumber = event.phoneNumber;
      this.blkContactName = event.contactName;
      this.lastBulkContactSearched = null;
    }
    else if (event) {
      this.blkContactName = event.contactName;
      this.blkContactNumber = null;
    }
    else {
      this.blkContactNumber = null;
      this.blkContactName = null;
      this.lastBulkContactSearched = null;
    }
  }

  public getPackagedContactPhone(event) {
    if (event && event.contactName && event.phoneNumber) {
      this.pkgContactNumber = event.phoneNumber;
      this.pkgContactName = event.contactName;
      this.lastPackagedContactSearched = null;
      if (event.deliveryInstructions) {
        this.cppDeliveryInstructionCode = event.deliveryInstructions.split(',');
      }
      else {
        this.cppDeliveryInstructionCode = new Array<string>();
      }
    }
    else if (event) {
      this.pkgContactName = event.contactName;
      this.pkgContactNumber = null;
      this.cppDeliveryInstructionCode = new Array<string>();
    }
    else {
      this.pkgContactNumber = null;
      this.pkgContactName = null;
      this.lastPackagedContactSearched = null;
      this.cppDeliveryInstructionCode = new Array<string>();
    }
  }

  public keyPressAlphaNumericWithSpace(event) {
    var inp = String.fromCharCode(event.keyCode);
    if (this.alphaNumericPatternWithSpace.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  //Formate Data from Add Product Slider Model
  formatNewAddedData(productList: any[]) {
    const orderList = [];
    this.filteredDataCount = 0;
    this.qtyCount = 0;
    this.totalPrice = 0;
    let rowId = 0;
    this.cppCoiProductItemsDataSource.data.forEach(x => {
      orderList.push(x);
      if (x.rowId > rowId) { rowId = x.rowId; }
    });
    productList.forEach(x => {
      rowId = rowId + 1;
      let duplicateData = orderList.find(y => y.itemId == x.itemId && y.orderUOM == x.orderUOM);
      if (duplicateData) {
        const index = orderList.indexOf(duplicateData);
        if (index !== -1) {
          orderList.splice(index, 1);
        }
        duplicateData = orderList.find(y => y.itemId == x.itemId && y.orderUOM == x.orderUOM);
      }

      if (duplicateData == undefined) {
        const newRow = {
          rowId: rowId,
          isSelected: false,
          isProductDetailDisplayed: false,
          itemId: x.itemId,
          itemNumber: x.itemNumber,
          itemDescription: x.itemDescription,
          itemVendorName: x.itemVendorName,
          packageSize: x.packageSize,
          gtin: x.gtin,
          activeIngredient: x.activeIngredient,
          productSegment: x.productSegment,
          productLine: x.productLine,
          palletQuantity: x.palletQuantity,
          restrictedUse: x.restrictedUse,
          returnable: x.returnable,
          uom: x.orderUOM,
          orderUOM: x.orderUOM,
          pricingUOM: x.pricingUOM,
          price: x.price,
          deliveryDate: x.desiredDelDate,
          defaultDeliveryDate: x.defaultDelDate,
          quantity: 1,
          lineErrors: { 'rowId': rowId, 'errors': [] },
          allowDecimal: x.allowDecimal,
          warningMessage: x.warningMessage,
          isLineSDM: x.isLineSDM,
          deliveryDateReason: x.deliveryDateChangeReason,
          AvailableUnits: x.availableUnits,
          isParent: x.isParent,
          bulkPackaged: x.bulkPackaged
        };

        this.qtyCount = this.qtyCount + x.orderQty;
        orderList.splice(orderList.length, 0, newRow);
      }
    });

    this.filteredDataCount = orderList.length;
    this.cppCoiProductItemsDataSource.data = orderList;
    this.cppCoiOriginalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
    this.showBulkContactDetails = this.cppCoiOriginalProductItemsDataSource.some(x => x.bulkPackaged.toUpperCase() === "BULK");
    this.showPackagedContactDetails = this.cppCoiOriginalProductItemsDataSource.some(x => x.bulkPackaged.toUpperCase() === "PACKAGED");
    this.validateDeliveryDateFilter();

    if (this.cppCoiProductItemsDataSource.data.length > 0) {
      this.disablecheckbox = false;
    }
    else {
      this.disablecheckbox = true;
    }
  }

  dateClass(element) {
    return (dDate: Date): MatCalendarCellCssClasses => {
      const todayDate = new Date();
      if (element.isLineSDM) {
        if (this.sdmSystemGeneratedDate == null) {
          this.sdmSystemGeneratedDate = new Date(element.defaultDeliveryDate);
        }

        const ngDate: NgbDate = new NgbDate(dDate.getFullYear(), dDate.getMonth() + 1, dDate.getDate());
        if (this.calendar.getWeekday(ngDate) < 7
          && dDate >= this.sdmSystemGeneratedDate) {
          if (this.selectedWeekdays.includes(this.calendar.getWeekday(ngDate))) {
            return 'holiday';
          }
          else {
            return 'mat-weekdays';
          }
        }
        else if (dDate >= todayDate
          && this.calendar.getWeekday(ngDate) < 7) {
          return 'mat-weekdays';
        }
        else {
          return undefined;
        }
      }
      else {
        return undefined;
      }
    };
  }

  quantityTextChange(productItem) {
    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.cppCoiOriginalProductItemsDataSource)).filter(x => x.rowId == productItem.rowId)[0];
    this.setCount();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldCPPCOIQtyValue: oldProductLineValue.quantity, newCPPCOIQtyValue: productItem.quantity });
    this.validateLineItem(productItem);

    this.isAddProductEnable = true;   // Enable Add Product Button
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  cppCoiUnitChange(action: string, productItem: any) {
    productItem.quantity = this.isNumber(productItem.quantity) == true ? productItem.quantity : 0;

    if (action == 'decrease') {
      const decValue = +productItem.quantity - 1;
      if (decValue > 0) {
        productItem.quantity = decValue;
      }
      else {
        productItem.quantity = 1;
      }
    }
    else {
      productItem.quantity = +productItem.quantity + 1;
    }

    if (productItem.allowDecimal) {
      productItem.quantity = (+productItem.quantity).toFixed(this.commonService.countDecimals(+productItem.quantity));
    }

    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.cppCoiOriginalProductItemsDataSource)).filter(x => x.rowId == productItem.rowId)[0];
    this.setCount();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldCPPCOIQtyValue: oldProductLineValue.quantity, newCPPCOIQtyValue: productItem.quantity });
    this.validateLineItem(productItem);

    this.isAddProductEnable = true;   // Enable Add Product Button
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  }

  fetchSDMReasonCodes() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppCoiRequestService.getDeliveryDateReasonList().subscribe((result: any[]) => {
      this.reasonList = result;
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  reasonCodeChange(element) {
    this.cppCoiProductItemsDataSource.data.forEach(item => {
      // update reason code if delivery dates are same
      if (item.rowId != element.rowId && item.isLineSDM
        && new Date(item.deliveryDate).getTime() == new Date(element.deliveryDate).getTime()) {
        item.deliveryDateReason = element.deliveryDateReason;
        this.validateLineItem(item);
      }
    });
    this.validateLineItem(element);
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  onOpen(element) {
    if (element.isLineSDM) {
      setTimeout(() => { this.appendFooter(); }, 0);
    }
  }

  appendFooter() {
    const matCalendar = document.getElementsByClassName('mat-datepicker-content')[0] as HTMLElement;
    matCalendar.appendChild(this.datepickerFooter.nativeElement);
  }
}

class InputErrorStateMatcher implements ErrorStateMatcher {
  constructor(private errorstate: boolean) { }
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return this.errorstate;
  }
}
